import React from "react";
import RolesListingTable from "./RolesListingTable";

const RoleManagement = () => {
  return <RolesListingTable />;
};

export default RoleManagement;
